import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nxt-app1-header',
  templateUrl: './app1-header.component.html',
  styleUrls: ['./app1-header.component.scss'],
})
export class App1HeaderComponent implements OnInit {
  
  constructor() {}

  ngOnInit(): void {}
}
